import { Box, Grid, Skeleton, Tooltip, Typography } from "@mui/material"
import { AutoDispatchInfo } from "../../AutoDispatchInfo/AutoDispatchInfo"
import { invoiceListStyles } from "../invoiceListStyles"
import { useContext, useRef } from "react"
import { LanguageContext } from "../../../../../utilities/contexts/LanguageContext"
import language from "../../../../../language/language"
import OnHoldFlag from '../../../../../assets/holdInvoice.svg'

const FlaggedCell = () => {
    const { currentLanguage } = useContext(LanguageContext)
    const flagRef = useRef<HTMLImageElement | null>(null)

    return (
        <Tooltip
            title={language[currentLanguage].onHoldTooltip}
            arrow={true}
            placement={'top-start'}
            PopperProps={{ anchorEl: flagRef.current }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img ref={flagRef} src={OnHoldFlag} alt={''} width={20} height={20} />
                <Typography sx={invoiceListStyles.storeName}>
                    {language[currentLanguage].onHold}
                </Typography>
            </Box>
        </Tooltip>
    )
}

export const renderFlaggedCell = (params: any) => {
    if (params.row.invoiceDetails.nssaInvoiceStatus === 'ON_HOLD') {
        return <FlaggedCell />
    }
    return null
}

export const searchAllPartNumbers = (parts: any) => {
    let concated = ''
    parts.map((part: any) => {
        let partNumber = part.partNumber
        return (concated = concated + ' ' + partNumber)
    })
    return concated
}


export const searchAllPartDescriptions = (parts: any) => {
    let concated = ''
    parts.map((part: any) => {
        let partDescription = part.description
        return (concated = concated + ' ' + partDescription)
    })
    return concated
}


export const renderSkeleton = () => {
    return (
        <>
            <Grid item xs={12}>
                <Skeleton variant={'text'} height={'52px'} animation={'wave'} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant={'text'} height={'52px'} animation={'wave'} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant={'text'} height={'52px'} animation={'wave'} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant={'text'} height={'52px'} animation={'wave'} />
            </Grid>
        </>
    )
}

export const renderAutoDispatchedColumn = (params: {
    row: { timeElapsed: number; invoiceDateTime: number, serviceLevel: string, autoDispatch: boolean, hold: boolean }
}) => {
    return (
        <Typography sx={invoiceListStyles.autoDispatch}>
            <AutoDispatchInfo
                timeElapsed={params.row.timeElapsed}
                invoiceDateTime={params.row.invoiceDateTime}
                wasHeld={!!params.row?.hold}
                autodashCancelled={!params.row?.autoDispatch && params.row?.serviceLevel === 'AUTODASH'}
            />
        </Typography>
    )
}

export const geColorBasedOnPriorityInMinutes = (priority: any) => {
    let colorCode = ''
    switch (true) {
        case priority <= 30:
            colorCode = '#D6D6D6'
            break
        case priority > 30 && priority <= 45:
            colorCode = '#FFE395'
            break
        case priority > 45 && priority <= 60:
            colorCode = '#ADADAD'
            break
        case priority > 60 && priority <= 75:
            colorCode = '#E49600'
            break
        case priority > 75:
            colorCode = ''
            break
    }
    return colorCode
}

export const getColorBasedOnServiceLevel = (serviceLevel: string, isCompanyOwned: boolean) => {
    let colorCode = '#ADADAD'
    switch (true) {
        case serviceLevel === 'PLATINUM':
            colorCode = '#D6D6D6'
            break
        case serviceLevel === 'GOLD':
            colorCode = '#FFE395'
            break
        case serviceLevel === 'SILVER':
            colorCode = '#ADADAD'
            break
        case serviceLevel === 'BRONZE' && !isCompanyOwned:
            colorCode = '#E49600'
            break
        case serviceLevel === 'AUTODASH':
            colorCode = '#fe5600'
            break
    }
    return colorCode
}